const SearchIcon = () => {
  return (
    <svg viewBox="0 0 11.454 11.454">
      <path
        d="M71.338,66.429a4.9,4.9,0,0,1,4,7.747l2.308,2.311a.818.818,0,1,1-1.157,1.157l-2.311-2.308a4.907,4.907,0,1,1-2.838-8.907Zm0,1.636a3.273,3.273,0,1,0,3.273,3.273A3.271,3.271,0,0,0,71.338,68.065Z"
        transform="translate(-66.429 -66.429)"
      />
    </svg>
  );
};

export default SearchIcon;
